import { LegalLayout } from "@/components/LegalLayout";
import { Mail, ShieldAlert, MessageCircle } from "lucide-react";

const Support = () => (
  <LegalLayout
    title="Support"
    description="How to reach the Cash Isle team."
    updated="May 13, 2026"
  >
    <p>We aim to respond within one business day.</p>

    <div className="not-prose grid sm:grid-cols-3 gap-3 my-6">
      <a
        href="mailto:support@cashisle.app"
        className="rounded-2xl border border-border bg-card p-4 hover:bg-muted/40"
      >
        <Mail className="h-5 w-5 text-primary mb-2" />
        <p className="font-display font-bold text-sm">General help</p>
        <p className="text-xs text-muted-foreground">support@cashisle.app</p>
      </a>
      <a
        href="mailto:trust@cashisle.app"
        className="rounded-2xl border border-border bg-card p-4 hover:bg-muted/40"
      >
        <ShieldAlert className="h-5 w-5 text-destructive mb-2" />
        <p className="font-display font-bold text-sm">Trust & safety</p>
        <p className="text-xs text-muted-foreground">trust@cashisle.app</p>
      </a>
      <a
        href="mailto:disputes@cashisle.app"
        className="rounded-2xl border border-border bg-card p-4 hover:bg-muted/40"
      >
        <MessageCircle className="h-5 w-5 text-accent mb-2" />
        <p className="font-display font-bold text-sm">Disputes & escrow</p>
        <p className="text-xs text-muted-foreground">disputes@cashisle.app</p>
      </a>
    </div>

    <h2>Before you contact us</h2>
    <ul>
      <li>Check the in-app activity for the transaction or gig in question.</li>
      <li>For disputes, open one in-app first — that captures the evidence.</li>
      <li>Include your cashtag and the relevant transaction or gig ID.</li>
    </ul>

    <h2>Security</h2>
    <p>
      To report a vulnerability, email{" "}
      <a href="mailto:security@cashisle.app">security@cashisle.app</a>. Do not
      post details publicly until we've responded.
    </p>
  </LegalLayout>
);

export default Support;
